import {useEffect, useState} from 'react'
import {BooksitoutServer} from '../../../config/BooksitoutServer'
import Paging from '../../../common/hooks/Paging'
import {BookRecommenderResponse} from './BookRecommenderResponse'

const useBookRecommenders = (size: number = 10) => {
    const [page, setPage] = useState<number>(1)
    const [isLast, setIsLast] = useState<boolean>(false)
    const [totalPages, setTotalPages] = useState<number>(0)
    const [isLoading, setIsLoading] = useState<boolean>(true)

    const [recommenders, setRecommenders] = useState<BookRecommenderResponse[]>([])

    useEffect(() => {
        if (!isLast) {
            BooksitoutServer
                .get(`/v1/book-recommenders?page=${page}&size=${size}`)
                .then((res) => {
                    setRecommenders((prev) => [...prev, ...res.data.contents])
                    setIsLast(res.data.isLast)
                    setTotalPages(res.data.totalPages)
                })
                .finally(() => setIsLoading(false))
        }
    }, [page])

    const fetchNext = () => {
        setPage(page + 1)
    }

    const paging: Paging = {
        hasMore: !isLast,
        totalPages: totalPages,
        fetchNext: fetchNext,
    }

    return [isLoading, recommenders, paging] as const
}

export default useBookRecommenders